






































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ExamineeStudentProgress } from '@/models/evalSetting/evaluator-student-progress';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import GExamDetailProgressChart from '@/views/GExamDetail/GExamDetailProgressChart.vue';
import { GEnum } from '@/constants/enum.defination';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { SchoolClass } from '@/models/school-class/school-class';

@Component({
  name: 'GExamDetailProgressClassCharts',
  components: { GExamDetailProgressChart },
  computed: {},
  methods: {},
})
export default class GExamDetailClassProgressCharts extends Vue {
  lazy: boolean = true;
  mounted() {}

  @Prop() schoolClass: SchoolClass;

  // クラス変更による表の再描画処理(強引)
  @Watch('selectedSchoolClassID')
  watchSelectedSchoolClassID(value: number) {
    this.lazy = false;
    setTimeout(() => {
      this.lazy = true;
    }, 1);
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get selectedSchoolClassID(): number {
    return evalSettingDetailModule.selectedSchoolClassID;
  }

  get colorTypeRed(): GEnum.ColorType {
    return GEnum.ColorType.Red;
  }

  get examineeStudentProgressesBySchoolClassID(): ExamineeStudentProgress[] {
    if (evalSettingDetailModule.examineeStudentProgressesBySchoolClassID.get(this.selectedSchoolClassID)) {
      return evalSettingDetailModule.examineeStudentProgressesBySchoolClassID.get(this.selectedSchoolClassID);
    }
  }
  get statusCompletedCountBySchoolClassID(): number {
    return this.examineeStudentProgressesBySchoolClassID.filter((progress: ExamineeStudentProgress) => progress.isStatusCompleted).length;
  }

  get selfCompletedCountBySchoolClassID(): number {
    return this.examineeStudentProgressesBySchoolClassID.filter((progress: ExamineeStudentProgress) => progress.isSelfProgressCompleted).length;
  }

  get giftCompletedCountBySchoolClassID(): number {
    return this.examineeStudentProgressesBySchoolClassID.filter((progress: ExamineeStudentProgress) => progress.isGiftProgressCompleted).length;
  }

  get iatCompletedCountBySchoolClassID(): number {
    return this.examineeStudentProgressesBySchoolClassID.filter((progress: ExamineeStudentProgress) => progress.isIatProgressCompleted).length;
  }

  get freeWordSkillCompletedCountBySchoolClassID(): number {
    return this.examineeStudentProgressesBySchoolClassID.filter((progress: ExamineeStudentProgress) => progress.isFreeWordSkillProgressCompleted).length;
  }

  get trendCompletedCountBySchoolClassID(): number {
    return this.examineeStudentProgressesBySchoolClassID.filter((progress: ExamineeStudentProgress) => progress.isTrendProgressCompleted).length;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic) ||
           this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademicReadOnly);
  }
}
